import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'kt-terms-dialog',
  templateUrl: './list-terms.component.html',
  styleUrls: ['./list-terms.component.scss']
})
export class listTermsComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
